export default __webpack_public_path__ + "static/media/icon_carousel.7c4a285b.svg";